import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/material_types',
    name: 'materialCategoryPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
